import { render, staticRenderFns } from "./reduction-button.vue?vue&type=template&id=4fb705da"
import script from "./reduction-button.vue?vue&type=script&lang=ts"
export * from "./reduction-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports